<template>
  <div>
    <vs-popup
      class="holamundo"
      :title="$t('OrderDetails')"
      :active.sync="isSidebarActiveLocal"
      fullscreen
    >
      <div v-if="orderDetailItem">
        <div class="flex flex-wrap items-center justify-between">
          <div class="flex items-center">
            <vs-button
              class="mb-base mr-3"
              icon-pack="feather"
              icon="icon icon-file"
              @click="printInvoice"
              >Print</vs-button
            >
          </div>
        </div>

        <vx-card id="invoice-container">
          <div ref="printable">
            <!-- INVOICE METADATA -->
            <div class="vx-row leading-loose p-base">
              <div class="vx-col w-1/2 mt-base">
                <h1>{{ orderDetailItem.OrderSource }}</h1>
              </div>
              <div class="vx-col w-1/2 text-right">
                <div class="invoice__invoice-detail mt-6">
                  <b-row>
                    <b-col> <h6>INVOICE NO. :</h6></b-col>
                    <b-col cols="2"
                      ><h6>{{ orderDetailItem.OrderNumber }}</h6></b-col
                    >
                  </b-row>
                  <b-row>
                    <b-col><h6>INVOICE DATE :</h6></b-col>

                    <b-col cols="2"
                      ><h6>{{ parseDate(orderDetailItem.OrderDate) }}</h6></b-col
                    >
                  </b-row>
                </div>
              </div>
              <div class="vx-col w-1/2 mt-12" style="text-align: center">
                <h5>{{ $t("Recepient") }}</h5>
                <vs-divider></vs-divider>
                <div class="invoice__recipient-info my-4">
                  <p class="items-center">
                    <feather-icon icon="UserIcon" svgClasses="h-4 w-4"></feather-icon>
                    <span class="ml-2"
                      >{{ orderDetailItem.ShipmentName }}
                      {{ orderDetailItem.ShipmentLastName }}</span
                    >
                  </p>

                  <p>{{ orderDetailItem.ShipmentAddress }}</p>
                  <p>
                    {{ orderDetailItem.ShipmentCity }}/{{
                      orderDetailItem.ShipmentDistirct
                    }}
                  </p>
                </div>
                <div class="invoice__recipient-contact">
                  <p class="flex items-center" v-if="orderDetailItem.ShipmentMail">
                    <feather-icon icon="MailIcon" svgClasses="h-4 w-4"></feather-icon>
                    <span class="ml-2">{{ orderDetailItem.ShipmentMail }}</span>
                  </p>
                  <p class="flex items-center" v-if="orderDetailItem.ShipmentPhone">
                    <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4"></feather-icon>
                    <span class="ml-2">{{ orderDetailItem.ShipmentPhone }}</span>
                  </p>
                </div>
              </div>
              <div class="vx-col w-1/2 mt-12" style="text-align: center">
                <h5>{{ $t("Invoice") }}</h5>
                <vs-divider></vs-divider>

                <div class="invoice__company-info my-4">
                  <p class="items-center">
                    <feather-icon icon="UserIcon" svgClasses="h-4 w-4"></feather-icon>
                    <span class="ml-2"
                      >{{ orderDetailItem.InvoiceName }}
                      {{ orderDetailItem.InvoiceLastName }}</span
                    >
                  </p>

                  <p>{{ orderDetailItem.InvoiceAddress }}</p>
                  <p>
                    {{ orderDetailItem.InvoiceCity }}/{{
                      orderDetailItem.InvoiceDistirct
                    }}
                  </p>
                </div>
                <div class="invoice__company-contact">
                  <p class="items-center" v-if="orderDetailItem.InvoiceMail">
                    <feather-icon icon="MailIcon" svgClasses="h-4 w-4"></feather-icon>
                    <span class="ml-2">{{ orderDetailItem.InvoiceMail }}</span>
                  </p>
                  <p class="items-center" v-if="orderDetailItem.InvoicePhone">
                    <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4"></feather-icon>
                    <span class="ml-2">{{ orderDetailItem.InvoicePhone }}</span>
                  </p>
                </div>
              </div>
              <div class="vx-col w-1/2 mt-12" style="text-align: center">
                <h5>{{ $t("Cargo") }}</h5>
                <vs-divider></vs-divider>
                <div class="invoice__recipient-info my-4">
                  <p>
                    {{ orderDetailItem.OrderCargoName }}
                  </p>
                  <p>{{ orderDetailItem.OrderCargoNumber }}</p>
                </div>
              </div>
            </div>

            <!-- INVOICE CONTENT --> 
            <div
              class="p-base"
              v-if="
                Array.isArray(orderDetailItem.Items) && orderDetailItem.Items.length > 0
              "
            >
              <!-- INVOICE TASKS TABLE -->
              <vs-table hoverFlat :data="orderDetailItem.Items">
                <!-- HEADER -->
                <template slot="thead">
                  <vs-th class="pointer-events-none">{{ $t("StockCode") }}</vs-th>
                  <vs-th class="pointer-events-none">{{ $t("Barcode") }}</vs-th>
                  <vs-th class="pointer-events-none">{{ $t("SellerCode") }}</vs-th>
                  <vs-th class="pointer-events-none">{{ $t("StockName") }}</vs-th>
                  <vs-th class="pointer-events-none">{{ $t("DepotQuantity") }}</vs-th>

                  <!-- <vs-th class="pointer-events-none">{{ $t("Price") }}</vs-th> -->
                  <vs-th class="pointer-events-none">{{ $t("Quantity") }}</vs-th> 
                </template>

                <!-- DATA -->
                <template slot-scope="{ data }">
                  <vs-tr
                    v-for="(tr, index) in data"
                    :key="index"
                    :class="
                      parseFloat(
                        data[index].DepotQuantity == null ||
                          data[index].DepotQuantity == ''
                          ? 0
                          : data[index].DepotQuantity
                      ) <= 0
                        ? 'bg-danger-list-ag'
                        : ''
                    "
                  >
                    <vs-td :data="data[index].OrderItemMarketPlaceCode">{{
                      data[index].OrderItemMarketPlaceCode
                    }}</vs-td>
                    <vs-td :data="data[index].OrderItemBarcode">{{
                      data[index].OrderItemBarcode
                    }}</vs-td>
                    <vs-td :data="data[index].OrderItemSellerCode">{{
                      data[index].OrderItemSellerCode
                    }}</vs-td>
                    <vs-td :data="data[index].OrderItemName"
                      >{{ data[index].OrderItemName }}
                    </vs-td>
                    <vs-td :data="data[index].DepotQuantity"
                      >{{ data[index].DepotQuantity }}
                    </vs-td>
                    <!-- <vs-td :data="data[index].OrderItemPrice"
                      >{{ data[index].OrderItemPrice }} {{ data[index].OrderCurrency }}
                    </vs-td> -->
                    <vs-td :data="data[index].OrderItemQuantity"
                      >{{ data[index].OrderItemQuantity }}
                    </vs-td>
                    
                  </vs-tr>
                </template>
              </vs-table>

              <!-- INVOICE SUMMARY TABLE 
              <vs-table hoverFlat class="w-1/2 ml-auto mt-4" :data="orderDetailItem">
                <vs-tr>
                  <vs-th class="pointer-events-none">{{ $t("Subtotal") }}</vs-th>
                  <vs-td
                    >{{ orderDetailItem.TotalPrice }}
                    {{ orderDetailItem.OrderCurrency }}</vs-td
                  >
                </vs-tr>
              </vs-table>--> 
            </div>
          </div>
        </vx-card>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import moment from "moment";

export default {
  data() {
    return {
      isPrinting: false,
      orderDetailItem: {
        Items: [], // Varsayılan olarak boş dizi
      },
    };
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      default: () => {},
    },
  },

  methods: {
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY HH:mm");
    },
    printInvoice() {
      const printContents = this.$refs.printable.innerHTML;
      const originalContents = document.body.innerHTML;

      const printWindow = window.open("", "", "height=600,width=800");
      printWindow.document.write("<html><head><title>Print</title>");
      printWindow.document.write("</head><body >");
      printWindow.document.write(printContents);
      printWindow.document.write("</body></html>");
      printWindow.document.close();
      printWindow.print();
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
  },
  watch: {
    isSidebarActive(val) {
      if (val == true) this.orderDetailItem = this.data;
      return val;
    },
    data(val) {
      return val;
    },
  },
};
</script>
<style lang="scss">
.bg-danger-list-ag {
  background-color: #f8cbcc !important;
}
</style>
